import { render } from "./EmailTemplateDetails.vue?vue&type=template&id=fb6399c2"
import script from "./EmailTemplateDetails.vue?vue&type=script&lang=js"
export * from "./EmailTemplateDetails.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__